document.addEventListener( 'DOMContentLoaded', function() {
	// Find all category dropdowns on the page in case there are multiple
	// we are using the name attribute to target the dropdowns because this is the only way to target them currently
	// If the name attribute changes, this will need to be updated.
	const categorySelects = document.querySelectorAll( '[name="releye_jobcategory2"]' );
	if ( ! categorySelects.length ) {
		// No category dropdowns found, exit early
		return;
	}

	const jobMap = {
		Sales: [
			'Sales Manager',
			'Sales Excellence Manager',
			'KAM',
			'Sales Rep/Account Manager',
			'CSO/Sales Director',
			'Other (Sales)',
		],
		Marketing: [
			'Marketing Manager',
			'CMO',
			'Marketing Coordinator/Assistant',
			'Marketing Specialist/Analyst',
			'Marketing Consultant',
			'Other (Marketing)',
		],
		Purchasing: [
			'Purchase Manager/Director',
			'Procurement Manager/Director',
			'Purchase/Procurement Specialist',
			'Purchase Assistant/Administrator',
			'Procurement Assistant/Administrator',
			'Other (Purchase/Procurement)',
		],
		'Customer Service': [
			'Customer Service Manager',
			'Customer Service Representative',
			'Other (Customer Service)',
		],
		General: [
			'Manager',
			'CIO/CDO',
			'CEO/Managing Director',
			'Head of Product Management',
			'Other (General)',
		],
		HR: [
			'HR Manager/Director',
			'Learning & Development Manager',
			'HR Specialist',
			'HR Assistant/Administrator',
			'Other (HR)',
		],
	};

	categorySelects.forEach( function( categorySelect ) {
		// For each category dropdown, find its containing form
		const form = categorySelect.closest( 'form' );

		if ( ! form ) {
			return;
		}

		// Find the corresponding job title dropdown in the same form
		const titleSelect = form.querySelector( '[name="releye_jobtitle"]' );

		if ( ! titleSelect ) {
			return;
		}

		// Cache all original options for this title dropdown
		const allOptions = Array.from( titleSelect.options );

		// Disable title dropdown initially
		titleSelect.disabled = true;

		// Add change listener scoped to this pair
		categorySelect.addEventListener( 'change', function() {
			const selectedCategory = categorySelect.selectedOptions[ 0 ]?.innerText.trim();

			if ( ! selectedCategory || ! jobMap[ selectedCategory ] ) {
				titleSelect.innerHTML = '';
				titleSelect.disabled = true;
				return;
			}

			const allowedTitles = new Set( jobMap[ selectedCategory ] );

			// Filter and rebuild options from cached list
			titleSelect.innerHTML = '';
			allOptions.forEach( option => {
				// Always keep default/empty/hidden options
				if ( ! option.value || option.hidden ) {
					titleSelect.appendChild( option.cloneNode( true ) );
					return;
				}

				const label = option.textContent.trim();
				if ( allowedTitles.has( label ) ) {
					titleSelect.appendChild( option.cloneNode( true ) );
				}
			} );

			titleSelect.disabled = false;
		} );
	} );
} );
